import React, {useContext} from "react";

import AppContext from "../../App/context";
import PostContext from "../../Post/context";

export default function Router(props) {

    const postContext = useContext(PostContext);
    const appContext = useContext(AppContext);
    const {user, post, statusManager} = postContext;
    const {userStatusManager} = appContext;
    const {page, pages, router, pageProps = {}} = props;

    const pageName = router({user, post, page, statusManager, userStatusManager});
    const Page = (pageName) ? pages[pageName] : null;

    return (Page) ? <Page {...pageProps} /> : null;
}
